import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  noindex?: boolean;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SEO({
  title,
  description,
  canonicalUrl,
  keywords,
  ogImage = "https://turkeyvacationguide.com/og-image.jpg",
  ogType = "website",
  noindex = false,
  articlePublishedTime,
  articleModifiedTime
}: SEOProps) {
  // Construct the full page title
  const fullTitle = title.includes("Turkey Guide") 
    ? title 
    : `${title} | Turkey Guide`;
  
  // Base URL
  const baseUrl = "https://turkeyvacationguide.com";
  
  // Generate canonical URL
  const fullCanonicalUrl = canonicalUrl 
    ? `${baseUrl}${canonicalUrl}` 
    : undefined;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {keywords && <meta name="keywords" content={keywords} />}
      {fullCanonicalUrl && <link rel="canonical" href={fullCanonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      {fullCanonicalUrl && <meta property="og:url" content={fullCanonicalUrl} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Article meta tags */}
      {articlePublishedTime && <meta property="article:published_time" content={articlePublishedTime} />}
      {articleModifiedTime && <meta property="article:modified_time" content={articleModifiedTime} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      {fullCanonicalUrl && <meta property="twitter:url" content={fullCanonicalUrl} />}
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
} 